import React from 'react';

/**
 * Shared page header: h1 + optional subtitle + optional toolbar slot (right side).
 *
 * props:
 * - title       : string — main heading
 * - subtitle    : string — optional muted line below the title
 * - children    : node   — optional toolbar (buttons/selects) rendered on the right
 * - as          : 'h1' | 'h2' (default 'h1')
 */
function PageHeader({ title, subtitle, children, as }) {
    const Heading = as === 'h2' ? 'h2' : 'h1';
    return (
        <div className="gh-page-head d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
            <div className="d-block mb-3 mb-md-0">
                <Heading className="h4">{title}</Heading>
                {subtitle ? <p className="gh-subtitle">{subtitle}</p> : null}
            </div>
            {children ? (
                <div className="btn-toolbar mb-2 mb-md-0">
                    {children}
                </div>
            ) : null}
        </div>
    );
}

export default PageHeader;
